// extracted by mini-css-extract-plugin
export default {"counterWrapper":"Counter_counterWrapper__SL6L6","counter":"Counter_counter__xCZHx"};